module.exports = "/static/assets/fbc0674b961eb36b3f0ffe37e1a292a4.png";